import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "my-profile-inner" }
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section-title two" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Create Job"),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1)
const _hoisted_8 = { class: "profile-form" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Job Information:")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "job_title" }, "Job Title*", -1)
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-inner mb-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Job Type*", -1)
const _hoisted_19 = { class: "input-area" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-inner mb-25" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Working Mode*", -1)
const _hoisted_24 = { class: "input-area" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "form-inner mb-25" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", null, "Payment Mode*", -1)
const _hoisted_29 = { class: "input-area" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-inner mb-25" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Qualification *", -1)
const _hoisted_34 = { class: "input-area" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/qualification-2.svg",
  alt: ""
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Qualification", -1)
const _hoisted_37 = ["label"]
const _hoisted_38 = ["value", "selected"]
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-inner mb-25" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", null, "Gender *", -1)
const _hoisted_42 = { class: "input-area" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-inner mb-25" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", null, "Job Category", -1)
const _hoisted_47 = { class: "input-area" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "form-inner mb-25" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "Job Location", -1)
const _hoisted_52 = { class: "input-area" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/category-2.svg",
  alt: ""
}, null, -1)
const _hoisted_54 = { class: "col-md-12" }
const _hoisted_55 = { class: "form-inner mb-25" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Job Description*", -1)
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = { class: "form-inner mb-25" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "vacancy" }, "Vacancies", -1)
const _hoisted_60 = { class: "input-area" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = { class: "form-inner mb-25" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "experience" }, "Experience (Years)", -1)
const _hoisted_65 = { class: "input-area" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = { class: "form-inner mb-25" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { for: "salary_from" }, "Salary (from)", -1)
const _hoisted_70 = { class: "input-area" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_72 = { class: "col-md-3" }
const _hoisted_73 = { class: "form-inner mb-25" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { for: "salary_from" }, "Salary (to)", -1)
const _hoisted_75 = { class: "input-area" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "form-inner mb-25" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { for: "salary_from" }, "Job Expiry", -1)
const _hoisted_80 = { class: "input-area" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_82 = { class: "col-md-12" }
const _hoisted_83 = { class: "form-inner" }
const _hoisted_84 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("form", _hoisted_8, [
                _hoisted_9,
                (_ctx.company)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jobForm.job_title) = $event)),
                              type: "text",
                              id: "job_title",
                              name: "job_title"
                            }, null, 512), [
                              [_vModelText, _ctx.jobForm.job_title]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeJobType,
                              modelValue: this.jobForm.job_type_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.jobForm.job_type_id) = $event)),
                              options: _ctx.jobTypes,
                              placeholder: "Select Job Type",
                              ref: "language",
                              optionLabel: "name",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            class: "text-danger",
                            name: "job_types"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeWorkingMode,
                              modelValue: this.jobForm.working_mode_Id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.jobForm.working_mode_Id) = $event)),
                              options: _ctx.working_modes,
                              ref: "language",
                              placeholder: "Select Working Mode",
                              optionLabel: "name",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changePaymentMode,
                              modelValue: this.jobForm.payment_mode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.jobForm.payment_mode) = $event)),
                              options: _ctx.payment_modes,
                              ref: "language",
                              placeholder: "Select Payment Mode",
                              optionLabel: "name",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _withDirectives(_createElementVNode("select", {
                              class: "form-select",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.jobForm.qualification_id) = $event)),
                              placeholder: "Select Qualification"
                            }, [
                              _hoisted_36,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qualifications, (group, index) => {
                                return (_openBlock(), _createElementBlock("optgroup", { label: index }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      value: item.id,
                                      selected: _ctx.jobForm.qualification_id == item.id
                                    }, _toDisplayString(item.name), 9, _hoisted_38))
                                  }), 256))
                                ], 8, _hoisted_37))
                              }), 256))
                            ], 512), [
                              [_vModelSelect, _ctx.jobForm.qualification_id]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeGender,
                              modelValue: this.jobForm.gender,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.jobForm.gender) = $event)),
                              options: _ctx.genders,
                              ref: "language",
                              placeholder: "Select Gender",
                              optionLabel: "name",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeCategory,
                              modelValue: this.jobForm.category_id,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.jobForm.category_id) = $event)),
                              options: _ctx.categories,
                              ref: "language",
                              placeholder: "Select Job Category",
                              optionLabel: "name",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("div", _hoisted_52, [
                            _hoisted_53,
                            _createVNode(_component_Dropdown, {
                              onChange: _ctx.changeState,
                              modelValue: this.jobForm.state_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.jobForm.state_id) = $event)),
                              options: _ctx.states,
                              ref: "language",
                              placeholder: "Select Job Location",
                              optionLabel: "name",
                              optionValue: "id",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["onChange", "modelValue", "options"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.jobForm.job_description) = $event)),
                            id: "description",
                            placeholder: "Job Description"
                          }, null, 512), [
                            [_vModelText, _ctx.jobForm.job_description]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.jobForm.vacancy) = $event)),
                              type: "text",
                              id: "vacancy",
                              name: "companyname",
                              placeholder: "Number of vacancies"
                            }, null, 512), [
                              [_vModelText, _ctx.jobForm.vacancy]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("div", _hoisted_65, [
                            _hoisted_66,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.jobForm.experience) = $event)),
                              type: "text",
                              id: "experience",
                              name: "experience",
                              placeholder: "1 year"
                            }, null, 512), [
                              [_vModelText, _ctx.jobForm.experience]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("div", _hoisted_70, [
                            _hoisted_71,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.jobForm.salary_from) = $event)),
                              type: "text",
                              id: "salary_from",
                              name: "salary_from",
                              placeholder: "Salary from"
                            }, null, 512), [
                              [_vModelText, _ctx.jobForm.salary_from]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, [
                            _hoisted_76,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.jobForm.salary_to) = $event)),
                              type: "text",
                              id: "salary_to",
                              name: "salary_to",
                              placeholder: "Salary to"
                            }, null, 512), [
                              [_vModelText, _ctx.jobForm.salary_to]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _hoisted_79,
                          _createElementVNode("div", _hoisted_80, [
                            _hoisted_81,
                            _createVNode(_component_Calendar, {
                              modelValue: _ctx.jobForm.expiration,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.jobForm.expiration) = $event)),
                              dateFormat: "dd/mm/yy"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.createJob && _ctx.createJob(...args))),
                                class: "primry-btn-2 lg-btn w-unset",
                                type: "button"
                              }, "Create Job"))
                            : (_openBlock(), _createElementBlock("button", _hoisted_84, _hoisted_87))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}